import { GiCancel } from 'react-icons/gi';
import { convertHexToRGB } from '../../../utils/commonFunctions';

interface ISkillBadge {
  badgeLabel: string;
  color: string;
  isEditing?: boolean;
  onClickRemove?: () => void;
}

const SkillBadge = ({
  badgeLabel,
  color,
  isEditing,
  onClickRemove,
}: ISkillBadge) => {
  // rendering profile badge component here
  return (
    <div
      style={{
        color,
        borderColor: color,
        backgroundColor: `rgba(${convertHexToRGB(color)}, 0.2)`,
      }}
      className='flex items-center gap-1 font-medium text-xs border-2 px-2 py-px rounded-full capitalize'
    >
      <div
        style={{ backgroundColor: color }}
        className='size-3 rounded-full'
      ></div>

      <p className='font-semibold'>{badgeLabel}</p>

      <button
        type='button'
        onClick={onClickRemove}
        className={`text-base-red hover:opacity-50 duration-300 ${
          isEditing ? 'block' : 'hidden'
        }`}
      >
        <GiCancel className='size-4' />
      </button>
    </div>
  );
};

export default SkillBadge;
